import CatamaranLight300Latin from './fonts/CatamaranLight300Latin.woff2';
import CatamaranLight300LatinExt from './fonts/CatamaranLight300LatinExt.woff2';
import CatamaranThin100Latin from './fonts/CatamaranThin100Latin.woff2';
import CatamaranThin100LatinExt from './fonts/CatamaranThin100LatinExt.woff2';

export default {
  CatamaranLight300Latin,
  CatamaranLight300LatinExt,
  CatamaranThin100Latin,
  CatamaranThin100LatinExt
};



// WEBPACK FOOTER //
// ./src/styles/fonts.js